import { createContext, useContext, useReducer } from 'react';
import { ACTION_TYPES, ManagementUnitsReducer, ManagementUnitsState } from './management-units-reducer';

const ManagementUnitsContext = createContext<ManagementUnitsState | undefined>(undefined);
const ManagementUnitsContextDispatchContext = createContext({} as any);

const ManagementUnitsProvider = ({ children }: { children: React.ReactNode }) => {
    const initialState: ManagementUnitsState = {
        units: [],
        loading: false,
        error: null,
    };

    const [state, dispatch] = useReducer(ManagementUnitsReducer, initialState);

    return (
        <ManagementUnitsContext.Provider value={state}>
            <ManagementUnitsContextDispatchContext.Provider value={dispatch}>
                {children}
            </ManagementUnitsContextDispatchContext.Provider>
        </ManagementUnitsContext.Provider>
    );
}

const useManagementUnitsState = () => {
    const context = useContext(ManagementUnitsContext);
    if (context === undefined) {
        throw new Error('useManagementUnitsState must be used within a ManagementUnitsProvider');
    }
    return context;
}

const useManagementUnitsDispatch = () => {
    const context = useContext(ManagementUnitsContextDispatchContext);
    if (context === undefined) {
        throw new Error('useManagementUnitsDispatch must be used within a ManagementUnitsProvider');
    }
    return context;
}

export { ManagementUnitsProvider, useManagementUnitsState, useManagementUnitsDispatch, ACTION_TYPES };
